import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ValidationService } from 'app/validation.service';
import { JobService } from 'app/jobService';

import { Router } from '@angular/router';
import { ActivatedRoute } from '@angular/router';
import { EmailValidator } from './../email';

@Component({
  selector: 'apply-job-section1',
  templateUrl: './apply-job-section1.component.html',
  styleUrls: ['./apply-job-section1.component.scss']
})
export class ApplyJobSection1Component implements OnInit {

  constructor(private formBuilder: FormBuilder, private js: JobService, private router: Router, private route: ActivatedRoute) {

  }

  applyJobID = 0;
  validate = true;
  userForm: any;

  url = "/applyjobsection2";

  statusData: Object[] = [
    { value: "โสด", statusName: "โสด" },
    { value: "สมรส", statusName: "สมรส" },
    { value: "ไม่ระบุ", statusName: "ไม่ระบุ" },
  ];

  jobData: Object[] = [
    { value: "พนักงานธุรการ", jobName: "พนักงานธุรการ" },
    { value: "พนักงานฝ่ายสื่อสารองค์กร", jobName: "พนักงานฝ่ายสื่อสารองค์กร" },
    { value: "พนักงานฝ่ายเทตโนโลยีสารสนเทศ", jobName: "พนักงานฝ่ายเทตโนโลยีสารสนเทศ" },
  ];

  eduData: Object[] = [
    { value: "ปริญญาตรี", eduName: "ปริญญาตรี" },
    { value: "ปริญญาโท", eduName: "ปริญญาโท" },
    { value: "ปริญญาเอก", eduName: "ปริญญาเอก" },
  ];

  ngOnInit() {
    this.js.navigate = 1;
    //?announce=' + this.js.announce + "&position=" + this.js.position
    if (this.js.getUrlParameter("announce") != null) {
      this.js.announce = this.js.getUrlParameter("announce");
    }
    if (this.js.getUrlParameter("position") != null) {
      this.js.jobPosition = this.js.getUrlParameter("position");
    }

    this.userForm = this.formBuilder.group({
      'applyJobID': [this.js.applyJobID],
      'firstName': [this.js.firstName, [Validators.required, Validators.minLength(3)]],
      'lastName': [this.js.lastName, [Validators.required, Validators.minLength(3)]],
      'gender': [this.js.gender, [Validators.required]],
      'status': [this.js.status, [Validators.required, Validators.minLength(3)]],
      'dateOfBirth': [this.js.dateOfBirth, [Validators.required, Validators.minLength(3)]],
      'age': [this.js.age, [Validators.required, Validators.minLength(2)]],
      'nationality': [this.js.nationality, [Validators.required, Validators.minLength(2)]],
      'religion': [this.js.religion, [Validators.required, Validators.minLength(2)]],
      'weight': [this.js.weight, [Validators.required, Validators.minLength(2)]],
      'height': [this.js.height, [Validators.required, Validators.minLength(2)]],
      'tel': [this.js.tel, [Validators.required, Validators.minLength(9)]],
      'email': [this.js.email, [Validators.required, Validators.minLength(3)]],
      //'email': [this.js.email, [Validators.required, Validators.minLength(3), EmailValidator.isValid]],
    });

    this.userForm.get('firstName').valueChanges.subscribe(value => {
      this.js.firstName = value;
    });

    this.userForm.get('lastName').valueChanges.subscribe(value => {
      this.js.lastName = value;
    });

    this.userForm.get('gender').valueChanges.subscribe(value => {
      this.js.gender = value;
    });

    this.userForm.get('status').valueChanges.subscribe(value => {
      this.js.status = value;
    });

    this.userForm.get('dateOfBirth').valueChanges.subscribe(value => {
      this.js.dateOfBirth = value;
    });

    this.userForm.get('age').valueChanges.subscribe(value => {
      this.js.age = value;
    });

    this.userForm.get('nationality').valueChanges.subscribe(value => {
      this.js.nationality = value;
    });

    this.userForm.get('religion').valueChanges.subscribe(value => {
      this.js.religion = value;
    });

    this.userForm.get('weight').valueChanges.subscribe(value => {
      this.js.weight = value;
    });

    this.userForm.get('height').valueChanges.subscribe(value => {
      this.js.height = value;
    });

    this.userForm.get('tel').valueChanges.subscribe(value => {
      this.js.tel = value;
    });

    this.userForm.get('email').valueChanges.subscribe(value => {
      this.js.email = value;
    });

  }

  hasExclamationMark(input: any) {
    alert(input.value);
    const hasExclamation = input.value.indexOf('@') >= 1;
    return hasExclamation ? null : { needsExclamation: true };
  }
  

  AddApplyJob() { 
    this.js.NewApplyJobAPI().subscribe(
      (applyJobID) => {
        if (Number(applyJobID) !== 0) {
          //เซฟลงสำเร็จ
          this.js.applyJobID = Number(applyJobID);
          this.js.LinkUploadVDO = this.js.LinkUploadVDO + Number(applyJobID);
          
          this.GoToapplyjobsection2();
        } else {
          //เซฟลงไม่สำเร็จ
          alert('ไม่สำเร็จ โปรดตรวจข้อมูลอีกครั้ง');
        }
      },
      (error) => { alert(JSON.stringify(error)) },
      () => {

      }
    );
  }

  GoToapplyjobsection2() {
    this.router.navigateByUrl('applyjobsection2');
  }

}



// WEBPACK FOOTER //
// ./src/app/apply-job-section1/apply-job-section1.component.ts